import { render, staticRenderFns } from "./detaliPageTitle.vue?vue&type=template&id=5f5d0f78&scoped=true"
import script from "./detaliPageTitle.vue?vue&type=script&lang=js"
export * from "./detaliPageTitle.vue?vue&type=script&lang=js"
import style0 from "./detaliPageTitle.vue?vue&type=style&index=0&id=5f5d0f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d0f78",
  null
  
)

export default component.exports